export interface UsuarioModel {
  tipo_sociedad: string;
  tipo_entidad: string;
  tipo_identificacion: string;
  documento: string;
  nombres: string;
  apellidos: string;
  correo: string;
  direccion: string;
  tipo_telefono?: string;
  telefono: string;
  celular: string;
  pais: string;
  departamento: string;
  departamento_nombre: string;
  municipio: string;
  municipio_nombre: string;
  comuna: string;
  comuna_nombre: string;
  barrio: string;
  barrio_nombre: string;
  genero: string;
  notificacion: boolean;
  politica: boolean;
}


export const initialValuesUsuarioModel = {
  tipo_sociedad: "N-Persona Natural",
  tipo_entidad: "NINGUNO",
  // tipo_identificacion: "",
  documento: "",
  nombres: "",
  apellidos: "",
  correo: "",
  direccion: "",
  telefono: "",
  celular: "",
  pais: null,
  departamento: "",
  departamento_nombre: null,
  municipio: "",
  municipio_nombre: null,
  comuna: "",
  comuna_nombre: null,
  barrio: "",
  barrio_nombre: null,
  genero: null,
  notificacion: false,
  politica: false,
};

export const initialValuesUsuarioJuridicoModel = {
  tipo_sociedad: "J-Persona Juridica",
  tipo_entidad: null,
  tipo_identificacion: "4-NIT",
  documento: "",
  nombres: "",
  apellidos: "",
  correo: "",
  direccion: "",
  tipo_telefono: "",
  telefono: "",
  celular: "",
  pais: null,
  departamento: "",
  departamento_nombre: null,
  municipio: "",
  municipio_nombre: null,
  comuna: "",
  comuna_nombre: "",
  barrio: "",
  barrio_nombre: "",
  genero: "",
  notificacion: false,
  politica: false,
};

export interface RecuperarContraseniaModel {
  documento: string;
  correo: string;
}

export const initialValuesRecuperarContraseniaModel = {
  documento: "",
  correo: ""
};